class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  } 

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mainHeaderMenuToggle = this.querySelector('header-menu details');
    this.mainHeaderMenuToggle.addEventListener('mouseover', this.onHeaderMenuToggle.bind(this));
    this.mainHeaderMenuToggle.addEventListener('mouseleave', this.onHeaderMenuFocusOut.bind(this));
  }

  onHeaderMenuFocusOut() {
    setTimeout(() => {
      this.querySelector('details').removeAttribute('open');
      document.body.classList.remove('HeaderMenu-active');
    })
  }
  onHeaderMenuToggle() {
    this.querySelector('details').setAttribute('open','');
    document.body.classList.add('HeaderMenu-active');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);



class HeaderMegaMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mainMegaMenuDetailsToggle = this.querySelector('.megamenu details');
    this.mainMegaMenuDetailsToggle.addEventListener('mouseover', this.onMegaMenuToggle.bind(this));
    this.mainMegaMenuDetailsToggle.addEventListener('mouseleave', this.onMegaMenuFocusOut.bind(this));
  }
  onMegaMenuFocusOut() {
    setTimeout(() => {
      this.querySelector('details').removeAttribute('open');
      document.body.classList.remove('megamenu-active');
    })
  }

  onMegaMenuToggle() {
    this.querySelector('details').setAttribute('open','');
    document.body.classList.add('megamenu-active');
  }
}
customElements.define('header-megamenu', HeaderMegaMenu);